import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

type CompleteSignUpInput = {
  token: string;
  firstName: string;
  lastName: string;
  organizationName: string;
  timezone: string;
  password: string;
};

export const completeSignUpMutationAtom = createMutationAtomFactory(
  'authentication.completeSignUp',
  ({
    token,
    firstName,
    lastName,
    organizationName,
    timezone,
    password,
  }: CompleteSignUpInput) => ({
    authenticationCompleteSignUp: {
      __args: {
        token,
        firstName,
        lastName,
        organizationName,
        timezone,
        password,
      },
      __typename: true,
      on_SignUpCompletedResult: {
        organizationId: true,
        userId: true,
        email: true,
        success: true,
      },
      on_InvalidSignUpInvitationError: {
        reason: true,
      },
    },
  }),
  { skipQueue: true }, // Skip queue for auth mutations
);
